import React from 'react';
import { 
  Button, 
  Typography, 
  Card, 
  Space,
  Divider,
  List
} from 'antd';
import { 
  LeftOutlined,
  CheckCircleOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Text, Paragraph } = Typography;

// 模拟二维码图片URL (实际项目中应替换为真实的企业微信二维码图片URL)
const qrCodeUrl = 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png';

const BindButlerSuccessPage: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <div style={{ 
      maxWidth: 500, 
      margin: '0 auto', 
      background: '#f5f5f5', 
      minHeight: '100vh'
    }}>
      {/* 顶部标题栏 */}
      <div style={{ 
        padding: '12px 16px', 
        background: '#fff', 
        display: 'flex',
        alignItems: 'center',
        borderBottom: '1px solid #f0f0f0',
      }}>
        <Button 
          type="text" 
          icon={<LeftOutlined />} 
          onClick={() => navigate(-1)}
          style={{ marginRight: 16 }}
        />
        <div style={{ fontSize: 16, fontWeight: 'bold' }}>绑定专属管家</div>
      </div>
      
      {/* 主内容区 */}
      <div style={{ padding: '20px 16px' }}>
        <Card 
          style={{ 
            borderRadius: 8, 
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            textAlign: 'center',
            marginBottom: 16 
          }}
        >
          <div style={{ 
            fontSize: 60, 
            color: '#52c41a', 
            marginBottom: 16,
            display: 'flex',
            justifyContent: 'center'
          }}>
            <CheckCircleOutlined />
          </div>
          
          <Title level={3} style={{ color: '#529C8A', marginBottom: 24 }}>
            专属管家绑定成功
          </Title>
          
          <Paragraph style={{ fontSize: 16, marginBottom: 20 }}>
            长按或用微信扫描下方二维码，添加企业微信好友，即刻获得一对一咨询与专属福利！
          </Paragraph>
          
          {/* 二维码区域 */}
          <div style={{ margin: '30px 0' }}>
            <img 
              src={qrCodeUrl} 
              alt="企业微信二维码" 
              style={{ 
                width: 220, 
                height: 220, 
                display: 'block', 
                margin: '0 auto',
                border: '4px solid #ffffff',
                boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
              }} 
            />
            <Text style={{ 
              display: 'block', 
              marginTop: 12, 
              color: '#666', 
              fontSize: 14 
            }}>
              长按图片保存或微信扫一扫
            </Text>
          </div>
        </Card>
        
        {/* 福利说明 */}
        <Card 
          title={<div style={{ fontSize: 16, fontWeight: 'bold' }}>添加后，您将享有：</div>}
          style={{ 
            borderRadius: 8, 
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)' 
          }}
        >
          <List
            itemLayout="horizontal"
            dataSource={[
              '1对1专属解答、极速响应',
              '活动资讯与专属福利抢先知',
              '全流程跟进/售后无忧'
            ]}
            renderItem={(item) => (
              <List.Item>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ 
                    width: 6, 
                    height: 6, 
                    backgroundColor: '#529C8A', 
                    borderRadius: '50%',
                    marginRight: 10 
                  }} />
                  <Text style={{ fontSize: 15 }}>{item}</Text>
                </div>
              </List.Item>
            )}
          />
          
          <Divider style={{ margin: '16px 0' }} />
          
          <Paragraph style={{ 
            textAlign: 'center', 
            color: '#666',
            fontSize: 14,
            margin: 0
          }}>
            秋果酒店 - 为您提供卓越的住宿体验
          </Paragraph>
        </Card>
      </div>
    </div>
  );
};

export default BindButlerSuccessPage; 